import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import { placeholder } from '../../assets/placeholder';
import ImageS3Upload from '../../components/ImageS3Upload';
import { addEquipment, getEquipment, removeEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import dayjs from 'dayjs';



export default function TaskEquipmentView(modalProps: any) {

  const id = modalProps?.id;

  const taskType = modalProps?.details?.task_type;

  async function nextMaintenanceWindow() {
    const nextMaintenanceWindow = dayjs(maintenanceDate).add(+maintenanceValue, maintenanceInterval).toDate();
    let createObject: any = {
      next_maintenance_window: nextMaintenanceWindow,
      maintenance_start_date: new Date(),
    };
    modalProps.setGlobalLoading(true);
    updateEquipment(createObject, id).then((r: any) => {
      setTimeout(() => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'Equipment Maintenance Window Updated', life: 3000 });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      }, 500);
    })
  }

  async function equipmentReplaced() {
    modalProps.setGlobalLoading(true);
    removeEquipment(id).then((r: any) => {
      setTimeout(() => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'Equipment Replaced Successfully', life: 3000 });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      }, 500);

    })
  }



  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [equipmentType, setEquipmentType] = React.useState("");
  const [equipmentTypeObject, setEquipmentTypeObject] = React.useState<any>({});
  const [serialNumber, setSerialNumber] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [purchasedDate, setPurchasedDate] = React.useState(new Date());
  const [maintenanceLabel, setMaintenanceLabel] = React.useState('');
  const [maintenanceValue, setMaintenanceValue] = React.useState('');
  const [maintenanceInterval, setMaintenanceInterval] = React.useState<any>("");
  const [expectedLifeLabel, setExpectedLifeLabel] = React.useState("");
  const [expectedLifeValue, setExpectedLifeValue] = React.useState("");
  const [expectedLifeInterval, setExpectedLifeInterval] = React.useState<any>("");
  const [maintenanceDate, setMaintenanceDate] = React.useState(new Date());
  const [riskAssessment, setRiskAssessment] = React.useState();
  const [photo, setPhoto] = React.useState(placeholder);
  const [s3Key, setS3Key] = React.useState('');
  const [file, setFile] = React.useState<File>();

  React.useEffect(() => {
    modalProps.setGlobalLoading(true);
    getEquipment(id).then((equipment: any) => {
      console.log("equipment == ", equipment);
      setName(equipment.name);
      setDescription(equipment.description);
      setEquipmentType(equipment.type);
      setEquipmentTypeObject(equipment.equipment_type_object);
      setSerialNumber(equipment.serial_number);
      setPrice(equipment.price);
      if (equipment.purchased_date) setPurchasedDate(new Date(equipment.purchased_date));
      setMaintenanceValue(equipment.maintenance_value);
      setMaintenanceInterval(equipment.maintenance_interval);
      setMaintenanceLabel(`${equipment.maintenance_value} ${equipment.maintenance_interval}`);
      setExpectedLifeValue(equipment.expected_life_value);
      setExpectedLifeInterval(equipment.expected_life_interval);
      setExpectedLifeLabel(`${equipment.expected_life_value} ${equipment.expected_life_interval}`);
      if (equipment.maintenance_start_date) setMaintenanceDate(new Date(equipment.maintenance_start_date));
      setRiskAssessment(equipment.risk_assessment);
      setPhoto(equipment.photo);
      modalProps.setGlobalLoading(false);
    }).catch((error) => {
      modalProps.setGlobalLoading(false);
      console.log("error == ", error);
    });
  }, [])

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl>
            <ImageS3Upload photo={photo} setPhoto={setPhoto} s3Key={`equipment/${id}`} file={file} setFile={setFile} />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>Name</FormLabel>
                <FormControl
                  sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
                >
                  <InputText value={name} onChange={(e) => setName(e.target.value)} type="text" readOnly className="p-inputtext-sm PrimeSmallInput" />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Serial Number</FormLabel>
                <InputText value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} readOnly type="text" className="p-inputtext-sm PrimeSmallInput" />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Description</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputTextarea value={description} placeholder="Description" readOnly onChange={e => setDescription(e.target.value)} />
            </FormControl>
          </FormControl>
        </Grid>
        <br />
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Equipment Type</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={equipmentType} placeholder="Equipment Type" className="p-inputtext-sm PrimeSmallInput" readOnly onChange={e => setEquipmentType(e.target.value)} />
            </FormControl>
          </FormControl>
        </Grid>
        <br />
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Purchased Date</FormLabel>
            <Calendar value={purchasedDate} onChange={(e) => setPurchasedDate(e.value || new Date())} disabled showIcon />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Last Maintenance Date</FormLabel>
            <Calendar value={maintenanceDate} onChange={(e) => setMaintenanceDate(e.value || new Date())} disabled showIcon />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Maintenance</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={maintenanceLabel} placeholder="Maintenance" className="p-inputtext-sm PrimeSmallInput" readOnly onChange={e => setMaintenanceLabel(e.target.value)} />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Expected Life</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={expectedLifeLabel} placeholder="Expected Life" className="p-inputtext-sm PrimeSmallInput" readOnly onChange={e => setExpectedLifeLabel(e.target.value)} />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Price</FormLabel>
            <InputText value={price} onChange={(e) => setPrice(e.target.value)} type="number" readOnly className="p-inputtext-sm PrimeSmallInput" />
          </FormControl>
        </Grid>
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          {
            taskType == 'equipment_maintenance' ?
              <Button type="button" icon="pi pi-wrench" label="Equipment Maintained" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => nextMaintenanceWindow()} /> :
              <Button type="button" icon="pi pi-replay" label="Equipment Replaced" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => equipmentReplaced()} />
          }
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}